import { useMutation } from '@tanstack/vue-query';

import financingFlow from '~/services/financing-flow-api/financing-flow';

interface CancelProjectParams {
  financingId: number;
  reason: string;
}

export default function useProjectCancellation() {
  function mutationFn({ financingId, reason }: CancelProjectParams) {
    return financingFlow.financings.cancelByProjectId(financingId, reason);
  }

  return useMutation({
    mutationFn,
    retry: 3,
  });
}
